const audioManager = {
  audios: [], // Track all audio instances

  // Register audio instance and its setter
  registerAudio(audioInstance) {
    this.audios.push(audioInstance);
  },

  // Unregister audio instance on unmount
  unregisterAudio(audioInstance) {
    this.audios = this.audios.filter((audio) => audio !== audioInstance);
  },

  // Pause all other audios except the current one
  pauseAllOthers(currentAudioInstance) {
    this.audios.forEach(({ setIsPlay }) => {
      if (currentAudioInstance !== setIsPlay) {
        setIsPlay(false); // Set others to "pause" state
      }
    });
  }
};

export default audioManager;
